import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('decimal', /^(\d+(?:[\.\,]\d{2})?)$/);
